module.exports = __webpack_public_path__ + "img/1010038810.5b20da3b.png";